import * as React from 'react';
import { Column } from "react-table";
import Table from "../../components/table/Table";
import { CLIENT_ROUTE, API_ROUTE, CLIENT_TITLE } from "./constants";
import type { IVersion } from "./types";
import Page from "../../components/layout/Page";
import { useListPage } from "../../hooks";
import RowActions from "../../components/table/RowActions";

interface IColorRecord extends Pick<IVersion, '_id' | 'versionNumber' | 'versionCode' | 'os'> {
    actions: unknown;
}

const ColorList = () => {

    const { records, handleInteraction, paginationState } = useListPage({
        clientRoute: CLIENT_ROUTE,
        apiRoute: API_ROUTE
    })

    const columns: Column<IColorRecord>[] =  [
        {
            Header: 'Үйлдлйин систем',
            accessor: 'os',
        },
        {
            Header: 'Хувилбар',
            accessor: 'versionCode',
        },
        {
            Header: 'Хувилбарын дугаар',
            accessor: 'versionNumber',
        },
        {
            Header: '',
            accessor: 'actions',
            Cell: (table) => {
                return (
                    <RowActions id={table.row.original._id} clientRoute={CLIENT_ROUTE}/>
                )
            }
        },
    ];

    return (
        <Page>
            <Page.Header title={CLIENT_TITLE}/>
            <Page.Body>
                <Table
                    searchable
                    columns={columns}
                    data={records}
                    totalPages={paginationState.totalPage}
                    onInteraction={handleInteraction}
                />
            </Page.Body>
        </Page>
    )
};

export default ColorList;